import { Layout, NotFound } from "@/components";
import { LOGIN_ROLES } from "@/lib/utils";
import {
  AddEditCurriculum,
  AddEditEmployee,
  AddEditGeographicalRegion,
  AddEditInventorySetup,
  AddEditSalesOpsTaskAssignment,
  AddEditSubmodule,
  AddEditTaskCategory,
  AddEditTaskTerm,
  AddEditTlmMaster,
  ChangePassword,
  Dashboard,
  EmployeeMgmt,
  ForgotPassword,
  Login,
  MasterData,
  SalesOpsDashboard,
  SalesOpsSchoolAdd,
  SalesOpsTaskMgmt,
  AddEditTaskConfig,
  AddEditTaskAssignment,
  TaskMgmt,
  School,
  AddEditMyTask,
  AddEditKit,
  Report
} from "@/pages";
import { AddEditInvoiceCode } from "@/pages/Admin/MasterData/TabsData/InvoiceCode";
import { AddEditTaskAssignmentSchool } from "@/pages/Finance/School/Add/TabsData/CrmMgmt/TaskManagement";
import {
  FinanceTeamEditInstallmentSchedule,
  FinanceTeamSchoolAdd,
  School_FinTeam,
} from "@/pages/Finance/School";
import { SalesOpsTeamEditInstallmentSchedule } from "@/pages/SalesOps/School/Add/TabsData";
import {
  Navigate,
  useRoutes,
  useLocation,
  Routes,
  Route,
} from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import { routes } from "./utils";

export const Router = () => {
  const location = useLocation();
  const state = (location.state || {}) as any;
  const backgroundLocation = state?.background;

  const routesConfig = [
    {
      path: routes.root,
      element: <Login />,
    },
    {
      path: routes.login,
      element: <Login />,
    },
    {
      path: routes.changePassword,
      element: <ChangePassword />,
    },
    {
      path: routes.forgotPassword,
      element: <ForgotPassword />,
    },
    {
      // Only admins allowed
      path: routes.admin,
      element: <ProtectedRoute allowedRoles={[LOGIN_ROLES.SUPER_ADMIN]} />,
      children: [
        {
          path: "",
          element: <Layout />,
          children: [
            {
              path: "",
              element: <Navigate to={`/${routes.admin}/${routes.dashboard}`} />,
            },
            {
              path: routes.dashboard,
              element: <Dashboard />,
            },
            {
              path: routes.masterData,
              element: <MasterData />,
              children: [
                {
                  path: `${routes.geoRegion}/${routes.action}`,
                  element: <AddEditGeographicalRegion />,
                },
                {
                  path: `${routes.geoRegion}/${routes.id}/${routes.action}`,
                  element: <AddEditGeographicalRegion />,
                },
                {
                  path: `${routes.taskCategory}/${routes.action}`,
                  element: <AddEditTaskCategory />,
                },
                {
                  path: `${routes.taskCategory}/${routes.id}/${routes.action}`,
                  element: <AddEditTaskCategory />,
                },
                {
                  path: `${routes.taskTerm}/${routes.action}`,
                  element: <AddEditTaskTerm />,
                },
                {
                  path: `${routes.taskTerm}/${routes.id}/${routes.action}`,
                  element: <AddEditTaskTerm />,
                },
                {
                  path: `${routes.submodule}/${routes.action}`,
                  element: <AddEditSubmodule />,
                },
                {
                  path: `${routes.submodule}/${routes.id}/${routes.action}`,
                  element: <AddEditSubmodule />,
                },
                {
                  path: `${routes.inventory}/${routes.action}`,
                  element: <AddEditInventorySetup />,
                },
                {
                  path: `${routes.inventory}/${routes.id}/${routes.action}`,
                  element: <AddEditInventorySetup />,
                },
                {
                  path: `${routes.tlmMaster}/${routes.action}`,
                  element: <AddEditTlmMaster />,
                },
                {
                  path: `${routes.tlmMaster}/${routes.id}/${routes.action}`,
                  element: <AddEditTlmMaster />,
                },
                {
                  path: `${routes.invoice_code}/${routes.action}`,
                  element: <AddEditInvoiceCode />,
                },
                {
                  path: `${routes.invoice_code}/${routes.id}/${routes.action}`,
                  element: <AddEditInvoiceCode />,
                },
                {
                  path: `${routes.curriculum}/${routes.action}`,
                  element: <AddEditCurriculum />,
                },
                {
                  path: `${routes.curriculum}/${routes.id}/${routes.action}`,
                  element: <AddEditCurriculum />,
                },
                {
                  path: `${routes.kit}/${routes.action}`,
                  element: <AddEditKit />,
                },
                {
                  path: `${routes.kit}/${routes.id}/${routes.action}`,
                  element: <AddEditKit />,
                },
              ],
            },
            {
              path: routes.school,
              children: [
                {
                  path: "",
                  element: <School />,
                },
                {
                  path: routes.action,
                  element: <SalesOpsSchoolAdd />,
                },
                {
                  path: `${routes.id}/${routes.action}`,
                  element: <FinanceTeamSchoolAdd />,
                },
                {
                  path: `${routes.id}/${routes.action}/${routes.myTask}/${routes.action}`,
                  element: <AddEditMyTask />,
                },
                {
                  path: `${routes.id}/${routes.action}/${routes.schoolTaskAssignment}/${routes.action}`,
                  element: <AddEditTaskAssignmentSchool />,
                },
                {
                  path: `${routes.id}/${routes.action}/${routes.myTask}/${routes.action}`,
                  element: <AddEditMyTask />,
                },
                {
                  path: `${routes.id}/${routes.action}/${routes.myTask}/${routes.id}/${routes.action}`,
                  element: <AddEditMyTask />,
                },
                {
                  path: `${routes.id}/${routes.action}/installment/:installmentIndex`,
                  element: <FinanceTeamEditInstallmentSchedule />,
                },
              ],
            },
            {
              path: routes.employee,
              element: <EmployeeMgmt />,
              children: [
                {
                  path: routes.action,
                  element: <AddEditEmployee />,
                },
                {
                  path: `${routes.id}/${routes.action}`,
                  element: <AddEditEmployee />,
                },
              ],
            },
            {
              path: routes.task,
              element: <TaskMgmt />,
              children: [
                {
                  path: `${routes.predefinedTask}/${routes.action}`,
                  element: <AddEditTaskConfig />,
                },
                {
                  path: `${routes.predefinedTask}/${routes.id}/${routes.action}`,
                  element: <AddEditTaskConfig />,
                },
                {
                  path: `${routes.taskAssignment}/${routes.action}`,
                  element: <AddEditTaskAssignment />,
                },
                {
                  path: `${routes.taskAssignment}/${routes.id}/${routes.action}`,
                  element: <AddEditTaskAssignment />,
                },
              ],
            },
            {
              path: routes.report,
              element: <Report />,
            },
          ],
        },
      ],
    },
    {
      // Only Sales Ops allowed
      path: routes.salesOps,
      element: <ProtectedRoute allowedRoles={[LOGIN_ROLES.SALES_OPS]} />,
      children: [
        {
          path: "",
          element: <Layout />,
          children: [
            {
              path: "",
              element: (
                <Navigate to={`/${routes.salesOps}/${routes.dashboard}`} />
              ),
            },
            {
              path: routes.dashboard,
              element: <SalesOpsDashboard />,
            },
            {
              path: routes.school,
              children: [
                {
                  path: "",
                  element: <School />,
                },
                {
                  path: routes.action,
                  element: <SalesOpsSchoolAdd />,
                },
                {
                  path: `${routes.id}/${routes.action}`,
                  element: <FinanceTeamSchoolAdd />,
                },
                {
                  path: `${routes.id}/${routes.action}/${routes.myTask}/${routes.action}`,
                  element: <AddEditMyTask />,
                },
                {
                  path: `${routes.id}/${routes.action}/${routes.myTask}/${routes.id}/${routes.action}`,
                  element: <AddEditMyTask />,
                },
                {
                  path: `${routes.id}/${routes.action}/installment/:installmentIndex`,
                  element: <FinanceTeamEditInstallmentSchedule />,
                },
              ],
            },
            // {
            //   path: routes.masterData,
            //   element: <SalesOpsMasterData />,
            //   children: [
            //     {
            //       path: `${routes.inventory}/${routes.action}`,
            //       element: <AddEditSalesOpsInventory />,
            //     },
            //     {
            //       path: `${routes.inventory}/${routes.id}/${routes.action}`,
            //       element: <AddEditSalesOpsInventory />,
            //     },
            //   ],
            // },
            {
              path: routes.task,
              element: <TaskMgmt />,
              children: [
                {
                  path: `${routes.myTask}/${routes.action}`,
                  element: <AddEditMyTask />,
                },
                {
                  path: `${routes.myTask}/${routes.id}/${routes.action}`,
                  element: <AddEditMyTask />,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      // Only Sales Ops allowed
      path: routes.finance_team,
      element: <ProtectedRoute allowedRoles={[LOGIN_ROLES.FINANCE_TEAM]} />,
      children: [
        {
          path: "",
          element: <Layout />,
          children: [
            {
              path: "",
              element: (
                <Navigate to={`/${routes.finance_team}/${routes.dashboard}`} />
              ),
            },
            {
              path: routes.dashboard,
              element: <Dashboard />,
            },
            {
              path: routes.school,
              children: [
                {
                  path: "",
                  element: <School_FinTeam />,
                },
                {
                  path: routes.action,
                  element: <FinanceTeamSchoolAdd />,
                },
                {
                  path: `${routes.id}/${routes.action}`,
                  element: <FinanceTeamSchoolAdd />,
                },
                {
                  path: `${routes.id}/${routes.action}/${routes.myTask}/${routes.action}`,
                  element: <AddEditMyTask />,
                },
                {
                  path: `${routes.id}/${routes.action}/${routes.schoolTaskAssignment}/${routes.action}`,
                  element: <AddEditTaskAssignmentSchool />,
                },
                {
                  path: `${routes.id}/${routes.action}/${routes.schoolTaskAssignment}/${routes.id}/${routes.action}`,
                  element: <AddEditTaskAssignmentSchool />,
                },
                {
                  path: `${routes.id}/${routes.action}/${routes.myTask}/${routes.id}/${routes.action}`,
                  element: <AddEditMyTask />,
                },
                {
                  path: `${routes.id}/${routes.action}/installment/:installmentIndex`,
                  element: <FinanceTeamEditInstallmentSchedule />,
                },
              ],
            },
            {
              path: routes.task,
              element: <TaskMgmt />,
              children: [
                {
                  path: `${routes.myTask}/${routes.action}`,
                  element: <AddEditMyTask />,
                },
                {
                  path: `${routes.myTask}/${routes.id}/${routes.action}`,
                  element: <AddEditMyTask />,
                },
              ],
            },
            {
              path: routes.report,
              element: <Report />,
            },
          ],
        },
      ],
    },
    {
      // Only CRM Heads allowed
      path: routes.crm_head,
      element: <ProtectedRoute allowedRoles={[LOGIN_ROLES.CRM_HEAD]} />,
      children: [
        {
          path: "",
          element: <Layout />,
          children: [
            {
              path: "",
              element: (
                <Navigate to={`/${routes.crm_head}/${routes.dashboard}`} />
              ),
            },
            {
              path: routes.dashboard,
              element: <Dashboard />,
            },
            {
              path: routes.school,
              children: [
                {
                  path: "",
                  element: <School_FinTeam />,
                },
                {
                  path: routes.action,
                  element: <FinanceTeamSchoolAdd />,
                },
                {
                  path: `${routes.id}/${routes.action}/${routes.schoolTaskAssignment}/${routes.action}`,
                  element: <AddEditTaskAssignmentSchool />,
                },
                {
                  path: `${routes.id}/${routes.action}/${routes.schoolTaskAssignment}/${routes.id}/${routes.action}`,
                  element: <AddEditTaskAssignmentSchool />,
                },
                {
                  path: `${routes.id}/${routes.action}`,
                  element: <FinanceTeamSchoolAdd />,
                },
                {
                  path: `${routes.id}/${routes.action}/installment/:installmentIndex`,
                  element: <FinanceTeamEditInstallmentSchedule />,
                },
              ],
            },
            {
              path: routes.task,
              element: <TaskMgmt />,
              children: [
                {
                  path: `${routes.predefinedTask}/${routes.action}`,
                  element: <AddEditTaskConfig />,
                },
                {
                  path: `${routes.predefinedTask}/${routes.id}/${routes.action}`,
                  element: <AddEditTaskConfig />,
                },
                {
                  path: `${routes.taskAssignment}/${routes.action}`,
                  element: <AddEditTaskAssignment />,
                },
                {
                  path: `${routes.taskAssignment}/${routes.id}/${routes.action}`,
                  element: <AddEditTaskAssignment />,
                },
                {
                  path: `${routes.myTask}/${routes.action}`,
                  element: <AddEditMyTask />,
                },
                {
                  path: `${routes.myTask}/${routes.id}/${routes.action}`,
                  element: <AddEditMyTask />,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      // Only Sales Ops allowed
      path: routes.lab_team_head,
      element: <ProtectedRoute allowedRoles={[LOGIN_ROLES.LABS_TEAM_HEAD]} />,
      children: [
        {
          path: "",
          element: <Layout />,
          children: [
            {
              path: "",
              element: (
                <Navigate to={`/${routes.lab_team_head}/${routes.dashboard}`} />
              ),
            },
            {
              path: routes.dashboard,
              element: <Dashboard />,
            },
            {
              path: routes.school,
              children: [
                {
                  path: "",
                  element: <School_FinTeam />,
                },
                {
                  path: routes.action,
                  element: <FinanceTeamSchoolAdd />,
                },
                {
                  path: `${routes.id}/${routes.action}`,
                  element: <FinanceTeamSchoolAdd />,
                },
                {
                  path: `${routes.id}/${routes.action}/${routes.schoolTaskAssignment}/${routes.action}`,
                  element: <AddEditTaskAssignmentSchool />,
                },
                {
                  path: `${routes.id}/${routes.action}/${routes.schoolTaskAssignment}/${routes.id}/${routes.action}`,
                  element: <AddEditTaskAssignmentSchool />,
                },
                {
                  path: `${routes.id}/${routes.action}/installment/:installmentIndex`,
                  element: <FinanceTeamEditInstallmentSchedule />,
                },
              ],
            },
            {
              path: routes.task,
              element: <TaskMgmt />,
              children: [
                {
                  path: `${routes.predefinedTask}/${routes.action}`,
                  element: <AddEditTaskConfig />,
                },
                {
                  path: `${routes.predefinedTask}/${routes.id}/${routes.action}`,
                  element: <AddEditTaskConfig />,
                },
                {
                  path: `${routes.taskAssignment}/${routes.action}`,
                  element: <AddEditTaskAssignment />,
                },
                {
                  path: `${routes.taskAssignment}/${routes.id}/${routes.action}`,
                  element: <AddEditTaskAssignment />,
                },
                {
                  path: `${routes.myTask}/${routes.action}`,
                  element: <AddEditMyTask />,
                },
                {
                  path: `${routes.myTask}/${routes.id}/${routes.action}`,
                  element: <AddEditMyTask />,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      // Only Sales Ops allowed
      path: routes.lab_team,
      element: <ProtectedRoute allowedRoles={[LOGIN_ROLES.LABS_TEAM]} />,
      children: [
        {
          path: "",
          element: <Layout />,
          children: [
            {
              path: "",
              element: (
                <Navigate to={`/${routes.lab_team}/${routes.dashboard}`} />
              ),
            },
            {
              path: routes.dashboard,
              element: <SalesOpsDashboard />,
            },
            {
              path: routes.school,
              children: [
                {
                  path: "",
                  element: <School_FinTeam />,
                },
                {
                  path: routes.action,
                  element: <FinanceTeamSchoolAdd />,
                },
                {
                  path: `${routes.id}/${routes.action}`,
                  element: <FinanceTeamSchoolAdd />,
                },
                {
                  path: `${routes.id}/${routes.action}/${routes.schoolTaskAssignment}/${routes.action}`,
                  element: <AddEditTaskAssignmentSchool />,
                },
                {
                  path: `${routes.id}/${routes.action}/${routes.schoolTaskAssignment}/${routes.id}/${routes.action}`,
                  element: <AddEditTaskAssignmentSchool />,
                },
                {
                  path: `${routes.id}/${routes.action}/${routes.myTask}/${routes.action}`,
                  element: <AddEditMyTask />,
                },
                {
                  path: `${routes.id}/${routes.action}/${routes.myTask}/${routes.id}/${routes.action}`,
                  element: <AddEditMyTask />,
                },
                {
                  path: `${routes.id}/${routes.action}/installment/:installmentIndex`,
                  element: <FinanceTeamEditInstallmentSchedule />,
                },
              ],
            },
            {
              path: routes.task,
              element: <TaskMgmt />,
              children: [
                {
                  path: `${routes.myTask}/${routes.action}`,
                  element: <AddEditMyTask />,
                },
                {
                  path: `${routes.myTask}/${routes.id}/${routes.action}`,
                  element: <AddEditMyTask />,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      // Only Sales Ops allowed
      path: routes.inventory_team,
      element: <ProtectedRoute allowedRoles={[LOGIN_ROLES.INVENTORY_TEAM]} />,
      children: [
        {
          path: "",
          element: <Layout />,
          children: [
            {
              path: "",
              element: (
                <Navigate
                  to={`/${routes.inventory_team}/${routes.dashboard}`}
                />
              ),
            },
            {
              path: routes.dashboard,
              element: <SalesOpsDashboard />,
            },
            {
              path: routes.school,
              children: [
                {
                  path: "",
                  element: <School_FinTeam />,
                },
                {
                  path: routes.action,
                  element: <FinanceTeamSchoolAdd />,
                },
                {
                  path: `${routes.id}/${routes.action}`,
                  element: <FinanceTeamSchoolAdd />,
                },
                {
                  path: `${routes.id}/${routes.action}/${routes.schoolTaskAssignment}/${routes.action}`,
                  element: <AddEditTaskAssignmentSchool />,
                },
                {
                  path: `${routes.id}/${routes.action}/${routes.schoolTaskAssignment}/${routes.id}/${routes.action}`,
                  element: <AddEditTaskAssignmentSchool />,
                },
                {
                  path: `${routes.id}/${routes.action}/${routes.myTask}/${routes.action}`,
                  element: <AddEditMyTask />,
                },
                {
                  path: `${routes.id}/${routes.action}/${routes.myTask}/${routes.id}/${routes.action}`,
                  element: <AddEditMyTask />,
                },
                {
                  path: `${routes.id}/${routes.action}/installment/:installmentIndex`,
                  element: <FinanceTeamEditInstallmentSchedule />,
                },
              ],
            },
            {
              path: routes.task,
              element: <TaskMgmt />,
              children: [
                {
                  path: `${routes.myTask}/${routes.action}`,
                  element: <AddEditMyTask />,
                },
                {
                  path: `${routes.myTask}/${routes.id}/${routes.action}`,
                  element: <AddEditMyTask />,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      // Only Sales Ops allowed
      path: routes.region_head,
      element: <ProtectedRoute allowedRoles={[LOGIN_ROLES.REGION_HEAD]} />,
      children: [
        {
          path: "",
          element: <Layout />,
          children: [
            {
              path: "",
              element: (
                <Navigate to={`/${routes.region_head}/${routes.dashboard}`} />
              ),
            },
            {
              path: routes.dashboard,
              element: <Dashboard />,
            },
            {
              path: routes.school,
              children: [
                {
                  path: "",
                  element: <School_FinTeam />,
                },
                {
                  path: routes.action,
                  element: <FinanceTeamSchoolAdd />,
                },
                {
                  path: `${routes.id}/${routes.action}`,
                  element: <FinanceTeamSchoolAdd />,
                },
                {
                  path: `${routes.id}/${routes.action}/${routes.schoolTaskAssignment}/${routes.action}`,
                  element: <AddEditTaskAssignmentSchool />,
                },
                {
                  path: `${routes.id}/${routes.action}/${routes.schoolTaskAssignment}/${routes.id}/${routes.action}`,
                  element: <AddEditTaskAssignmentSchool />,
                },
                {
                  path: `${routes.id}/${routes.action}/${routes.myTask}/${routes.action}`,
                  element: <AddEditMyTask />,
                },
                {
                  path: `${routes.id}/${routes.action}/${routes.myTask}/${routes.id}/${routes.action}`,
                  element: <AddEditMyTask />,
                },
                {
                  path: `${routes.id}/${routes.action}/installment/:installmentIndex`,
                  element: <FinanceTeamEditInstallmentSchedule />,
                },
              ],
            },
            {
              path: routes.task,
              element: <TaskMgmt />,
              children: [
                {
                  path: `${routes.predefinedTask}/${routes.action}`,
                  element: <AddEditTaskConfig />,
                },
                {
                  path: `${routes.predefinedTask}/${routes.id}/${routes.action}`,
                  element: <AddEditTaskConfig />,
                },
                {
                  path: `${routes.taskAssignment}/${routes.action}`,
                  element: <AddEditTaskAssignment />,
                },
                {
                  path: `${routes.taskAssignment}/${routes.id}/${routes.action}`,
                  element: <AddEditTaskAssignment />,
                },
                {
                  path: `${routes.myTask}/${routes.action}`,
                  element: <AddEditMyTask />,
                },
                {
                  path: `${routes.myTask}/${routes.id}/${routes.action}`,
                  element: <AddEditMyTask />,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      // Only Sales Ops allowed
      path: routes.relationship_manager,
      element: (
        <ProtectedRoute allowedRoles={[LOGIN_ROLES.RELATIONSHIP_MANAGER]} />
      ),
      children: [
        {
          path: "",
          element: <Layout />,
          children: [
            {
              path: "",
              element: (
                <Navigate
                  to={`/${routes.relationship_manager}/${routes.dashboard}`}
                />
              ),
            },
            {
              path: routes.dashboard,
              element: <Dashboard />,
            },
            {
              path: routes.school,
              children: [
                {
                  path: "",
                  element: <School_FinTeam />,
                },
                {
                  path: routes.action,
                  element: <FinanceTeamSchoolAdd />,
                },
                {
                  path: `${routes.id}/${routes.action}`,
                  element: <FinanceTeamSchoolAdd />,
                },
                {
                  path: `${routes.id}/${routes.action}/${routes.schoolTaskAssignment}/${routes.action}`,
                  element: <AddEditTaskAssignmentSchool />,
                },
                {
                  path: `${routes.id}/${routes.action}/${routes.schoolTaskAssignment}/${routes.id}/${routes.action}`,
                  element: <AddEditTaskAssignmentSchool />,
                },
                {
                  path: `${routes.id}/${routes.action}/${routes.myTask}/${routes.action}`,
                  element: <AddEditMyTask />,
                },
                {
                  path: `${routes.id}/${routes.action}/${routes.myTask}/${routes.id}/${routes.action}`,
                  element: <AddEditMyTask />,
                },
                {
                  path: `${routes.id}/${routes.action}/installment/:installmentIndex`,
                  element: <FinanceTeamEditInstallmentSchedule />,
                },
              ],
            },
            {
              path: routes.task,
              element: <TaskMgmt />,
              children: [
                {
                  path: `${routes.myTask}/${routes.action}`,
                  element: <AddEditMyTask />,
                },
                {
                  path: `${routes.myTask}/${routes.id}/${routes.action}`,
                  element: <AddEditMyTask />,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      path: "*",
      element: <NotFound />,
    },
  ];

  const backgroundElement = useRoutes(
    routesConfig,
    (backgroundLocation as any) || (location as any)
  );
  const modalElement = backgroundLocation
    ? useRoutes(routesConfig, location as any)
    : null;

  return (
    <>
      {backgroundElement}
      {modalElement}
    </>
  );
};
